import { initializeNeuroGuide } from '@ignitesales/neuro-application';
import wsfsOnlineConsumerReducer from '../reducers/wsfs-online-consumer-reducer.mjs';
import App from '../App';
import AppLoading from '../AppLoading';
import loadFonts from '../utils/loadFonts';
import logger from '../utils/logger.mjs';
import messages from '../i18n/messages';
import customMessages from "../i18n/custom";

const initGuide = async () => {
  loadFonts();

  await initializeNeuroGuide({
    AppComponent: App,
    AppLoadingComponent: AppLoading,
    messages: messages,
    reducers: [ wsfsOnlineConsumerReducer ],
    guideConfig: {
      customMessages: customMessages,
    }
  });

  logger.info('Guide application is ready for takeoff!');
};

initGuide();
